import { DataService } from './../reports/dataService';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../environments/environment';
import * as CryptoJS from 'crypto-js';
import { LogOutService } from '../modules/shared/stores/logOut/logOut.service';
import { logoutAction } from '../modules/shared/stores/logOut/logOut.action';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { verifyOrganizationLoginDetails } from '../login/models/authenticatonSetup.models';

@Injectable({ providedIn: 'root' })
export class AccountUserService {
    private userSubject: BehaviorSubject<any>;
    public user: Observable<any>;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    encryptSecretKey = "LionO3602.0CRM2021";
    constructor(
        private router: Router,
        private http: HttpClient,
        private jwtHelper: JwtHelperService,
        private dataService: DataService,
        // private logOutService: LogOutService,
        private store: Store, private messageService: MessageService
    ) {
        // To set for developer only to skip login every time. Got to remove this in production. starts from here .
        // if(window.location.hostname === 'localhost') {
        //    localStorage.setItem('randomstr', 'TUEA8');
        //     localStorage.setItem('liono360', '{"isSuccess":true,"reason":"","emailId":"xitij@upadpro.in","loginAuditId":460,"userID":9,"organizationId":3,"organizationName":"Incomm Agent Solution","roleId":1,"roleName":"Administrator","token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxNWE3ZTE5MS0yZjlmLTRhZDYtOTBhZi1kYjZhOTE1NzcxYTMiLCJleHAiOjE2MTQ3NDA0MjZ9.Wg3SAkk88_c13vZ6fnJFX4IDvwIcn8oJ7uJ46sSzk-c"}');
        // } // till here.
        const data = localStorage.getItem('liono360');
        const decrypt = this.decode(data);
        this.userSubject = new BehaviorSubject<any>(decrypt);
        this.user = this.userSubject.asObservable();
    }

    public get userValue(): any {
        return this.userSubject.value;
    }

    decode(data) {
        if (data) {
            const decrypted = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
            if (decrypted) {
                try {
                    const str = decrypted.toString(CryptoJS.enc.Utf8);
                    if (str.length > 0) {
                        return JSON.parse(str);
                    } else {
                        return 'error 1';
                    }
                } catch (e) {
                    return 'error 2';
                }
            }
            return 'error 3';
        }
        return ''
    }


    login(user) {

        return this.http.post(`${environment.apiUrlLogin}`, user, { headers: this.headers })
            .toPromise()
            .then((userres: any) => {
                if (environment?.isCookieEnable != true) {
                    localStorage.setItem('access_token', userres.AccessToken);
                }
                const finalToken = environment?.isCookieEnable == true ?
                    this.jwtHelper.decodeToken(userres.AccessToken) :
                    this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
                const userData = {
                    emailId: finalToken.EmailId,
                    isSuccess: finalToken.IsSuccess,
                    loginAuditId: finalToken.LoginAuditId,
                    organizationId: finalToken.OrganizationId,
                    organizationName: finalToken.OrganizationName,
                    reason: finalToken.Reason,
                    roleId: finalToken.RoleId,
                    roleName: finalToken.RoleName,
                    sessionId: finalToken.SessionId,
                    timeZone: userres.TimeZone,
                    token: finalToken.AuthToken,
                    userId: finalToken.UserId,
                    userName: finalToken.UserName,
                    userIP: finalToken.UserSource,
                    sourceType: finalToken.SourceType,
                    exp: finalToken.exp,
                    userLangingPage: userres?.UserLandingPage||'/'
                }
                // let userResult = <any>userres;
                // userResult.userIP = user.userIP;
                if (userData.isSuccess) {
                    const msg = JSON.stringify(userData);
                    const result = CryptoJS.AES.encrypt(msg, this.encryptSecretKey).toString();
                    localStorage.setItem('liono360', result);
                    this.userSubject.next(userData);
                }
                return userData;
            });
    }


    forgotPassword(user): Observable<any> {
        return this.http.put(
            `${environment.apiUrlLogout}ForgotPasswordLink`,
            user
        );
    }

    logout(reload = false) {
        this.http.put(`${environment.apiUrlLogout}Logout`, "").toPromise()
            .then(res => {
                this.clearLoginSession(reload);
            }).catch(res => {
                this.clearLoginSession(reload);
            });
    }

    autoLogout() {
        this.clearLoginSession();
        let xhr = new XMLHttpRequest()
        xhr.open("PUT", `${environment.apiUrlLogout}Logout`, false);
        xhr.setRequestHeader('content-type', 'application/json');
        if (environment?.isCookieEnable != true) {
            xhr.setRequestHeader('AccessToken', localStorage.getItem('access_token'));
        }
        xhr.send();
    }

    clearLoginSession(reload = false) {
        //console.log('logout res', res)
        localStorage.removeItem('liono360');
        localStorage.removeItem('randomstr');
        localStorage.removeItem('userPermissions');
        localStorage.removeItem('allChannelsUserPermissions');
        localStorage.removeItem('LionO360_Object');
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');

        this.userSubject.next(null);
        this.dataService.clearAllData();

        //this.store.dispatch(logoutAction());

        if (reload == true) {
            window.location.reload(); //reload after idle session out
            //this.router.navigate(['/login']);
        } else {
            this.router.navigate(['/login']);
        }
    }

    setUserSubject(user = null) {
        this.userSubject.next(user);
    }

    register(user: any) {
        return this.http.post(`${environment.apiUrl}/users/register`, user);
    }

    getAll() {
        return this.http.get<any[]>(`${environment.apiUrl}/users`);
    }

    updatePassword(user) {
        return this.http.put(`${environment.apiUrlLogout}ChangePassword?emailId=${user.emailId}&oldPassword=${user.oldPassword}&newPassword=${user.newPassword}`, null)
            .toPromise()
            .then(res => res)
            .catch(res => res);
    }

    getById(id: string) {
        return this.http.get<any>(`${environment.apiUrl}/users/${id}`);
    }

    update(id, params) {
        return this.http.put(`${environment.apiUrl}/users/${id}`, params)
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
                if (id == this.userValue.id) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    localStorage.setItem('liono360', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                }
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiUrl}/users/${id}`)
            .pipe(map(x => {
                // auto logout if the logged in user deleted their own record
                if (id == this.userValue.id) {
                    this.logout();
                }
                return x;
            }));
    }

    getIPAddress() {
        return this.http.get("https://api.ipify.org/?format=json");
    }

    reportIssue(reportIssue: any){
        return this.http.post(`${environment.appUrl}Ticket/SupportTicket`, reportIssue);
    }

    getReportIssueModule(organizationId:number,userId:number){
        return this.http.get(`${environment.appOrgUrl}Organization/SubscribedModules/${organizationId}/${userId}`)
    }


    onSubmitforgotPassword(userDetail) {
            return this.http.post(`${environment.apiUrlLogout}ChangePasswordLink`, userDetail);
    }

    verifyEmailForResetPassword(emailId, accessCode) {
        return this.http.get(`${environment.apiUrlLogout}ValidateLink?userid=${emailId}&accessCode=${accessCode}`);
    }

    checkUserSession(loginDetials) {
        return this.http.post(`${environment.apiUrlLogout}MultipleLogin`,loginDetials);
    }

    authenticationSetup(loginDetials) {
        return this.http.post(`${environment.apiUrlLogout}LoginAuth`,loginDetials);
    }

    // verifyLogin(loginDetials) {
    //     return this.http.post(`${environment.apiUrlLogout}LoginVerification`,loginDetials);
    // }
    authenticationSetupDirect(userres) {
                if (environment?.isCookieEnable != true) {
                    localStorage.setItem('access_token', userres.AccessToken);
                }
                const finalToken = environment?.isCookieEnable == true ?
                    this.jwtHelper.decodeToken(userres.AccessToken) :
                    this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
                const userData = {
                    emailId: finalToken.EmailId,
                    isSuccess: finalToken.IsSuccess,
                    loginAuditId: finalToken.LoginAuditId,
                    organizationId: finalToken.OrganizationId,
                    organizationName: finalToken.OrganizationName,
                    reason: finalToken.Reason,
                    roleId: finalToken.RoleId,
                    roleName: finalToken.RoleName,
                    sessionId: finalToken.SessionId,
                    timeZone: userres.TimeZone,
                    token: finalToken.AuthToken,
                    userId: finalToken.UserId,
                    userName: finalToken.UserName,
                    userIP: finalToken.UserSource,
                    sourceType: finalToken.SourceType,
                    exp: finalToken.exp,
                    userLangingPage: userres?.UserLandingPage||'/'
                }
                // let userResult = <any>userres;
                // userResult.userIP = user.userIP;
                if (userData.isSuccess) {
                    const msg = JSON.stringify(userData);
                    const result = CryptoJS.AES.encrypt(msg, this.encryptSecretKey).toString();
                    localStorage.setItem('liono360', result);
                    this.userSubject.next(userData);
                }
                return userData;

    }

    verifyLogin(user) {

        return this.http.post(`${environment.apiUrlLogout}LoginVerification`, user, { headers: this.headers })
            .toPromise()
            .then((userres: any) => {
                if (environment?.isCookieEnable != true) {
                    localStorage.setItem('access_token', userres.AccessToken);
                }
                const finalToken = environment?.isCookieEnable == true ?
                    this.jwtHelper.decodeToken(userres.AccessToken) :
                    this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
                const userData = {
                    emailId: finalToken.EmailId,
                    isSuccess: finalToken.IsSuccess,
                    loginAuditId: finalToken.LoginAuditId,
                    organizationId: finalToken.OrganizationId,
                    organizationName: finalToken.OrganizationName,
                    reason: finalToken.Reason,
                    roleId: finalToken.RoleId,
                    roleName: finalToken.RoleName,
                    sessionId: finalToken.SessionId,
                    timeZone: userres.TimeZone,
                    token: finalToken.AuthToken,
                    userId: finalToken.UserId,
                    userName: finalToken.UserName,
                    userIP: finalToken.UserSource,
                    sourceType: finalToken.SourceType,
                    exp: finalToken.exp,
                    userLangingPage: userres?.UserLandingPage||'/',
                    RKey:userres.RKey
                }
                // let userResult = <any>userres;
                // userResult.userIP = user.userIP;
                if (userData.isSuccess) {
                    const msg = JSON.stringify(userData);
                    const result = CryptoJS.AES.encrypt(msg, this.encryptSecretKey).toString();
                    localStorage.setItem('liono360', result);
                    this.userSubject.next(userData);
                }
                return userData;
            });
    }

    setUpAuthen(loginDetials: any) {
        return this.http.post(`${environment.apiUrlLogout}SetupAuth`,loginDetials);
    }

    resendOtp(data:any) {
        return this.http.post(`${environment.apiUrlLogout}ResendOTP`,data);
    }

    reSetupAuthen(data:any) {
        return this.http.post(`${environment.apiUrlLogout}ResetMFA`,data);
    }

    verifyAuthenSetUpLogin(user) {

        return this.http.post(`${environment.apiUrlLogout}SetupAuthVerification`, user, { headers: this.headers })
            .toPromise()
            .then((userres: any) => {
                if (environment?.isCookieEnable != true) {
                    localStorage.setItem('access_token', userres.AccessToken);
                }
                const finalToken = environment?.isCookieEnable == true ?
                    this.jwtHelper.decodeToken(userres.AccessToken) :
                    this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
                const userData = {
                    emailId: finalToken.EmailId,
                    isSuccess: finalToken.IsSuccess,
                    loginAuditId: finalToken.LoginAuditId,
                    organizationId: finalToken.OrganizationId,
                    organizationName: finalToken.OrganizationName,
                    reason: finalToken.Reason,
                    roleId: finalToken.RoleId,
                    roleName: finalToken.RoleName,
                    sessionId: finalToken.SessionId,
                    timeZone: userres.TimeZone,
                    token: finalToken.AuthToken,
                    userId: finalToken.UserId,
                    userName: finalToken.UserName,
                    userIP: finalToken.UserSource,
                    sourceType: finalToken.SourceType,
                    exp: finalToken.exp,
                    userLangingPage: userres?.UserLandingPage||'/'
                }
                // let userResult = <any>userres;
                // userResult.userIP = user.userIP;
                if (userData.isSuccess) {
                    const msg = JSON.stringify(userData);
                    const result = CryptoJS.AES.encrypt(msg, this.encryptSecretKey).toString();
                    localStorage.setItem('liono360', result);
                    this.userSubject.next(userData);
                }
                return userData;
            });
    }

    countryCode() {
        return this.http.get(`${environment.apiUrlLogout}CountryCode`);
    }

    updateUserTimeZone(){
        return this.http.get(`${environment.authenticationApi}User/TimeZone`)
            .toPromise()
            .then((timezoneDetails: any) => {
                const userData = this.decode(localStorage.getItem('liono360'));

                if(userData && timezoneDetails){
                    userData.timeZone.dstOffSetTimeInSeconds = timezoneDetails?.dstOffSetTimeInSeconds;
                    userData.timeZone.isDayLight = timezoneDetails?.isDayLight;
                    const msg = JSON.stringify(userData);
                    const result = CryptoJS.AES.encrypt(msg, this.encryptSecretKey).toString();
                    localStorage.setItem('liono360', result);
                    this.userSubject.next(userData);
                }
            }).catch(err => {

            });
    }

    verifyOrgLoginDetails(data:verifyOrganizationLoginDetails) {
        return this.http.post(`${environment.apiUrlLogout}UserAuthentication`,data);
    }

    recoverOrgLoginDetails(data: any) {
        return this.http.put<any>(`${environment.apiUrlLogout}ForgotOrganizationId`, data);
    }

}
